import React from "react";
import { TextField, TextFieldProps } from "@mui/material";
import styles from "./styles.module.scss";

interface AuthInputProps extends Omit<TextFieldProps, "label"> {
	label?: string;
	renderLabelHeader?: () => React.ReactNode;
}

export const CustomTextField: React.FC<AuthInputProps & { children?: React.ReactNode }> = ({ label, renderLabelHeader, id, children, ...props }) => {
	return (
		<div className={styles.inputGroup}>
			<div className={styles.header}>
				{renderLabelHeader
					? renderLabelHeader()
					: label && (
							<label
								htmlFor={id}
								className={styles.label}
							>
								{label}
							</label>
						)}
			</div>
			<TextField
				id={id}
				fullWidth
				variant="outlined"
				{...props}
			/>
			{children}
		</div>
	);
};
